import React from 'react';
import SingleColumnLayout from '../../../components/layout/SingleColumnLayout';
import AsyncProfile from './personalprofile/async';
import {Trans} from 'react-i18next';

const parent1 = {
  title: <Trans i18nKey="p.contactus.parent.title">Home</Trans>,
  path: '/',
};

export default [
  <SingleColumnLayout
    exact
    key="a"
    className="kt-portlet--solid-gray"
    path="/profile-settings"
    component={AsyncProfile}
    title={
      <Trans i18nKey="p.g.a.profile.edit.title">Edit Personal Profile</Trans>
    }
    parents={[parent1]}
  />,
];
